module.exports = __webpack_public_path__ + "img/mock.1b8b027e.png";